export default {
  itens: [
    {
      texto: "Dashboard",
      grupo: "dashboard", // grupo da rota, para que a drawer saiba o que está ativo e fique aberta
      route: { name: "dashboard" }, // mesma coisa que o :to
      icon: "mdi mdi-view-dashboard",
      permissoes: [], //exibe se atender uma das permissões (OR), deixe vazio para qualquer
      submenus: [],
    },
    {
      texto: "Financeiro",
      grupo: "financeiro",
      icon: "mdi mdi-cash-usd",
      permissoes: [],
      submenus: [
        {
          texto: "Formas de pagamento",
          route: { name: "forma-pagamento-list" },
          icon: "mdi mdi-credit-card-settings-outline",
          permissoes: ["formapgto.listar"],
        },
        {
          texto: "Contas bancárias",
          route: { name: "conta-bancaria-list" },
          icon: "mdi mdi-bank-plus",
          permissoes: ["contabancaria.listar_contas"],
        },
        {
          texto: "Contas a Receber",
          route: { name: "contas-receber-list" },
          icon: "mdi mdi-cash-multiple",
          permissoes: ["financeiro.listar_contas_receber"],
        },
        {
          texto: "Cnab",
          route: { name: "cnab-list" },
          icon: "mdi mdi-bank-transfer-out",
          permissoes: ["financeiro.criar_cnab"],
        },
      ],
    },
    {
      texto: "Itens",
      grupo: "itens",
      icon: "mdi mdi-sitemap",
      permissoes: [
        "item.listar_item",
        "grupo.listar_grupo",
        "subgrupo.listar_subgrupo",
        "un_medida.listar_unidade",
      ],
      submenus: [
        {
          texto: "Grupos de item",
          icon: "mdi mdi-group",
          route: { name: "grupo-item-list" },
          permissoes: ["grupo.listar_grupo"],
        },
        {
          texto: "Sub-Grupos de item",
          icon: "mdi mdi-ungroup",
          route: { name: "sub-grupo-item-list" },
          permissoes: ["subgrupo.listar_subgrupo"],
        },
        {
          texto: "Unidades de medida",
          icon: "mdi mdi-beaker-outline",
          route: { name: "unidade-medida-list" },
          permissoes: ["un_medida.listar_unidade"],
        },
        {
          texto: "Itens",
          icon: "mdi mdi-sitemap",
          route: { name: "item-list" },
          permissoes: ["item.listar_item"],
        },
      ],
    },
    {
      texto: "Grupo Engeguind",
      grupo: "empresas",
      icon: "mdi mdi-domain",
      permissoes: ["empresas.listar_empresas"],
      route: { name: "empresas-list" },
      submenus: [],
    },
    {
      texto: "Clientes",
      icon: "mdi mdi-account-tie",
      grupo: "cliente",
      permissoes: ["cliente.listar_clientes"],
      submenus: [
        {
          texto: "Cadastro de clientes",
          icon: "mdi mdi-account-multiple-plus",
          route: { name: "cliente-list" },
          permissoes: ["cliente.listar_clientes"],
        },
      ],
    },
    {
      texto: "Fornecedores",
      icon: "mdi mdi-dolly",
      grupo: "fornecedor",
      permissoes: ["fornecedor.listar_fornecedores"],
      submenus: [
        {
          texto: "Cadastro de fornecedores",
          icon: "mdi mdi-account-plus",
          route: { name: "fornecedor-list" },
          permissoes: ["fornecedor.listar_fornecedores"],
        },
      ],
    },
    {
      texto: "Funcionários",
      icon: "mdi mdi-account-hard-hat",
      grupo: "funcionario",
      permissoes: ["funcionario.listar_funcionario"],
      submenus: [
        {
          texto: "Cadastro de funcionários",
          icon: "mdi mdi-account-multiple-plus",
          route: { name: "funcionario-list" },
          permissoes: ["funcionario.listar_funcionario"],
        },
      ],
    },
    {
      texto: "Vendedores",
      icon: "mdi mdi-account-tie-outline",
      grupo: "vendedor",
      permissoes: ["vendedor.listar_vendedor"],
      submenus: [
        {
          texto: "Cadastro de vendedores",
          icon: "mdi mdi-account-multiple-plus",
          route: { name: "vendedor-list" },
          permissoes: ["vendedor.listar_vendedor"],
        },
      ],
    },
    {
      texto: "Equipamentos",
      icon: "mdi mdi-truck",
      grupo: "equipamento",
      permissoes: [
        "equipamento.listar_equipamento",
        "equipamento.listar_equipamento_medicao",
      ],
      submenus: [
        {
          texto: "Cadastro de equipamentos",
          icon: "mdi mdi-fire-truck",
          route: { name: "equipamento-list" },
          permissoes: ["equipamento.listar_equipamento"],
        },
        {
          texto: "Equipamentos p/ medição",
          icon: "mdi mdi-truck-delivery-outline",
          route: { name: "equipamento-medicao-list" },
          permissoes: ["equipamento.listar_equipamento_medicao"],
        },
      ],
    },
    {
      texto: "Obras",
      icon: "mdi mdi-office-building",
      grupo: "obras",
      permissoes: ["obras.listar_obras"],
      submenus: [
        {
          texto: "Ordem de Medição",
          icon: "mdi mdi-view-grid-outline",
          route: { name: "ordem-medicao-list" },
          permissoes: ["obras.listar_ordem_medicao"],
        },
      ],
    },
    {
      texto: "Documentos",
      icon: "mdi mdi-file-document-multiple",
      grupo: "documentos",
      permissoes: [
        "documentos.listar_pacotes",
        "documentos.relatorio_vencimentos",
      ],
      submenus: [
        {
          texto: "Pacotes de documentos",
          icon: "mdi mdi-package-variant",
          route: { name: "pacote-documento-list" },
          permissoes: ["documentos.listar_pacotes"],
        },
        {
          texto: "Relatório de vencimentos",
          icon: "mdi mdi-file-clock-outline",
          route: { name: "relatorio-vencimentos" },
          permissoes: ["documentos.relatorio_vencimentos"],
        },
      ],
    },
    {
      texto: "Relatórios",
      icon: "mdi mdi-file-chart",
      grupo: "relatorios",
      permissoes: ["relatorios.relatorio_contas_receber_1", "relatorios.relatorio_vendas_1", "relatorios.relatorio_contas_receber_vend"],
      submenus: [
        {
          texto: "Vendas",
          icon: "mdi mdi-file-chart",
          route: { name: "vendas-relatorio-1" },
          permissoes: ["relatorios.relatorio_vendas_1"],
        },
        {
          texto: "Movimentação de Títulos em Aberto",
          icon: "mdi mdi-file-chart",
          route: { name: "contas-receber-relatorio-1" },
          permissoes: ["relatorios.relatorio_contas_receber_1"],
        },
        {
          texto: "Acompanhamento de comissões",
          icon: "mdi mdi-file-chart",
          route: { name: "contas-receber-relatorio-vendedor" },
          permissoes: ["relatorios.relatorio_contas_receber_vend"],
        }
      ],
    },
    {
      texto: "Acesso",
      icon: "mdi mdi-shield-account",
      grupo: "acesso",
      permissoes: ["auth.listar_usuario", "auth.listar_permissoes"],
      submenus: [
        {
          texto: "Cadastro de usuários",
          icon: "mdi mdi-account-circle",
          route: { name: "usuarios-list" },
          permissoes: ["auth.listar_usuarios"],
        },
        {
          texto: "Permissões de acesso",
          icon: "mdi mdi-shield-alert-outline",
          route: { name: "permissoes-list" },
          permissoes: ["auth.listar_permissoes"],
        },
      ],
    },
    {
      texto: "Parâmetros",
      icon: "mdi mdi-cogs",
      grupo: "parametros",
      permissoes: ["params.tipos_documento"],
      submenus: [
        {
          texto: "Documentos",
          permissoes: [
            "params.tipos_documento",
            "params.tipos_proprietario_doc",
          ],
          submenus: [
            {
              texto: "Tipos de proprietário",
              icon: "mdi-file-account-outline",
              route: { name: "tipo-proprietario-doc-list" },
              permissoes: ["params.tipos_proprietario_doc"],
            },
            {
              texto: "Tipos de documento",
              icon: "mdi mdi-file-cog-outline",
              route: { name: "tipo-documento-list" },
              permissoes: ["params.tipos_documento"],
            },
          ],
        },
      ],
    },
  ],
  plain() {
    const arr = [];
    for (let item of this.itens) {
      arr.push(item);
      if (item.submenus) {
        for (let sub of item.submenus) {
          arr.push(sub);
        }
      }
    }
    return arr;
  },
};
